export async function callGTMEvent(eventname, data = {}) {
    var userDev = getDeviceType();
    var eventLang = $('html').attr('lang');
    var dataLayerTemp = data;
    dataLayerTemp['event'] = eventname;
    dataLayerTemp['user_device'] = userDev;
    dataLayerTemp['event_lang'] = eventLang;
    if (typeof dataLayerTemp.email !== 'undefined'){
        var email = dataLayerTemp.email;
        delete dataLayerTemp.email;
    } else var email = '';

    let dataLayerGTM = JSON.parse(JSON.stringify(dataLayerTemp));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(dataLayerGTM);

    const MoengagePromise = new Promise((MoengageResolve, MoengageReject) => {
        if (typeof Moengage != 'undefined') {
            let dataLayerMoE = JSON.parse(JSON.stringify(dataLayerTemp));
            var eventname = dataLayerMoE.event;
            delete dataLayerMoE.event;
            switch (eventname) {
                case 'im_signUp':
                case 'im_login':
                case 'submitDetails':
                    Moengage.add_unique_user_id(email)
                    .then(() => Moengage.add_email(email))
                    .then(() => Moengage.track_event(eventname, dataLayerMoE))
                    .then(() => MoengageResolve())
                    .catch(error => {
                        console.log(error);
                        MoengageResolve();
                    });
                    break;
                case 'im_logOut':
                    Moengage.destroy_session()
                    .then(() => MoengageResolve())
                    .catch(error => {
                        console.log(error);
                        MoengageResolve();
                    });
                    break;
                default:
                    Moengage.track_event(eventname, dataLayerMoE)
                    .then(() => MoengageResolve())
                    .catch(error => {
                        console.log(error);
                        MoengageResolve();
                    });
            } 

            // added to force success if Moengage is down and error catching fails
            setTimeout(() => {MoengageResolve()}, 2000);
        } else MoengageResolve();
    });
    
    if (typeof window.smartech == 'function') {
        let dataLayerNetcore = JSON.parse(JSON.stringify(dataLayerTemp));
        var eventname = dataLayerNetcore.event;
        delete dataLayerNetcore.event;
        switch (eventname) {
            case 'im_signUp':
            case 'im_login':
            case 'submitDetails':
                try {
                    smartech('contact', '2', {
                        'pk^email': email,
                    });
                    smartech('identify', email);
                    smartech('dispatch', eventname, dataLayerNetcore);
                } catch(error) {console.log(error);};
                break;
            case 'im_logOut':
                try {
                    smartech('identify', ' ');
                } catch(error) {console.log(error);};
                break;
            default:
                try {
                    smartech('dispatch', eventname, dataLayerNetcore);
                } catch(error) {console.log(error);};
        } 
    }

    return MoengagePromise;
}

// Added for datalayer
const getDeviceType = () => {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "Tablet";
    }
    if (
        /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
            ua
        )
    ) {
        return "Mobile";
    }
    return "Desktop";
};